import { useContext } from 'react'
import { Button, Col, Row } from 'react-bootstrap'
import DashboardContext from '../../Context'
import PropTypes from 'prop-types';
/**
 * این کامپوننت برای نمایش  دکمه افزودن و یرایش در بخش های زیر است 
 * در این کامپوننت درصورت داشتن دسترسی کاربر به افزودن و ویرایش بخش نمایش داده می شود
 */
export default function CreateCancelmicro({ ismicro, actions }) {

    const { handelEdit, handeldmicro, showformmicro } = useContext(DashboardContext)


    const handelEditform = (id) => {
        if (ismicro) {
            handeldmicro(false)
        }

        handelEdit(id)
    }

    const additem = () => {
        if (ismicro) {
            handeldmicro(true)
        }
    }

    return (
        <Row>
            <Col md={12} sm={12} xs={12} >
                {
                    showformmicro ?
                        <Button variant='danger' className='mb-3' onClick={() => handelEditform('')} >لغو</Button>
                        : actions.includes("Create") ?
                            <button type="button" className="btn btn-primary btn-icon-text btn-sm" onClick={additem} >
                                افزودن {" "}
                                <i className="fa fa-plus fa-lg"></i>
                            </button>
                            : null
                }
            </Col>
        </Row>
    )
}
CreateCancelmicro.propTypes = {
    /**ارایه دسترسی های کاربر */
    actions: PropTypes.array,
};